<template>
    <div class="action-item">
    <b-tabs :class="flat ? 'nav-tabs-flat' : ''">
        <b-tab title="Details" class="">
            <b-form >
                <b-row>
                    <b-col cols="6">
                        <b-form-group
                                label="Assigned to:"
                                label-for="reviewer"
                                label-size="sm"
                        >
                                <assign-select
                                    v-if="allowedAssign"
                                    ref="assignSelect"
                                    v-model="reviewer"
                                    @confirm="updateAssignee($event)"
                                    :options="assignOptions"
                                    :loading="form.loading.reviewer"
                                    :confirm-buttons="true"
                                    :disabled="true"
                                >
                                </assign-select>
                            <div v-else
                                class="b-form-group-content">
                                {{ reviewer.label }}
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                      <b-form-group
                          label="Status"
                          label-size="sm"
                      >
                        <div class="b-form-group-content">
                          {{ clientAction.status | uppercaseFirst }} {{ subStatus | uppercaseFirst | brackets }}
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group
                                label="Photos"
                                label-size="sm"
                        >
                            <photo-viewer
                                v-if="clientAction.numberOfPhotos > 0"
                                :photoFn="getPhotosFn"
                                thumbnailKeyBy="largeThumbnailUrl"
                                filenameKeyBy="filename"
                            >
                                <template #text>
                                    <span class="d-none d-md-inline">Show Photos</span>
                                </template>
                            </photo-viewer>
                            <b-btn v-else
                                    variant="yellow"
                                   size="sm"
                                   :disabled="true">
                                No photos<span class="d-none d-md-inline"> found</span>
                            </b-btn>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group
                                label="Tags"
                                label-size="sm"
                        >
                            <tag-select
                                v-if="allowedToTag && showTags"
                                ref="tagSelect"
                                v-model="tags"
                                :confirm-buttons="true"
                                :disabled="!allowedToTag"
                                :loading="form.loading.tags"
                            ></tag-select>
                            <b-badge
                                    v-else-if="tags.length > 0"
                                    variant="primary"
                                    pill
                                     v-for="tag in tags"
                                     :key="tag.name"
                                     tag="div"
                            >
                                {{ tag.name }}
                            </b-badge>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group
                                label="Linked Risk Assessment Action"
                                label-size="sm"
                        >
                            <div
                                 class="b-form-group-content">
                                {{ (clientAction.linkedActionId) ? clientAction.linkedAction.label : '' }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        <b-form-group
                                label="Due date"
                                label-size="sm"
                        >
                            <date-picker
                                    v-if="authorized"
                                    ref="datePicker"
                                    id="dueDate"
                                    v-model="clientAction.dueDate"
                                    :loading="form.loading.dueDate"
                                    :target-date="clientAction.dueDate"
                                    :confirm-buttons="true"
                                    :reduceButtons="true"
                                    @confirm="updateDueDate"
                            >
                            </date-picker>
                            <div v-else
                                 class="b-form-group-content">
                                {{ clientAction.dueDate | formatDate }}
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group
                                label="Priority"
                                label-size="sm"
                        >
                            <client-action-priority-select
                                    v-if="authorized"
                                    ref="prioritySelect"
                                    v-model="priority"
                                    @confirm="updatePriority($event)"
                                    :options="priorityOptions"
                                    :loading="form.loading.priority"
                                    :confirm-buttons="true"
                                    :disabled="true"
                            >
                            </client-action-priority-select>
                            <div v-else
                                 class="b-form-group-content">
                                {{ clientAction.clientActionPriority }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="this.canViewWorkOrders">
                    <b-col cols="6">
                        <b-form-group
                                label="Work Order"
                                label-size="sm"
                        >
                            <text-field
                                    ref="workOrder"
                                    id="workOrder"
                                    v-model="clientAction.workOrder"
                                    :loading="form.loading.workOrder"
                                    :placeholder="clientAction.workOrder"
                                    @confirm="updateWorkOrder"
                            >
                            </text-field>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <b-form-group
                                label="Compliance"
                                label-size="sm"
                        >
                            <div  class="b-form-group-content">
                                {{ clientAction.complianceType }}
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group
                          label="Assessment Type"
                          label-size="sm"
                      >
                        <div  class="b-form-group-content">
                          {{ clientAction.assessmentType }}
                        </div>
                      </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" v-for="(category, key) in categoryForm"
                           v-show="category.hidden ? !category.hidden(categoryForm) : true">
                        <b-form-group
                                :label="category.label"
                                label-size="sm"
                        >
                            <category-select
                                    v-if="authorized"
                                    :ref="key"
                                    :trackByValue="category.trackBy"
                                    :trackByLabel="category.labelBy"
                                    v-model="category.value"
                                    @confirm="saveCategories($event, key)"
                                    :disabled="category.disabled"
                                    :options="category.options"
                                    :loading="form.loading.clientActionSubCategory"
                                    :confirm-buttons="true"
                            >
                            </category-select>
                            <div v-else
                                 class="b-form-group-content">
                                {{ category.value ? category.value.clientActionCategory : '' }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row v-for="(row, index) in form.readOnly" :key="index">
                    <b-col v-for="(label, field) in row" cols="6">
                        <b-form-group
                            :label="label.length ? label : label.label"
                            label-size="sm"
                        >
                            <div class="b-form-group-content read-only">
                              <b-table
                                  v-if="label.items"
                                  :class="label.class"
                                  :items="label.items"
                                  :fields="label.fields"
                              />
                              <span v-else v-text="getFormValue(field)"></span>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-tab>
        <b-tab title="Action History"
               @click="getNotes"
        >
            <vue-element-loading :active="tabs.notes.loading"></vue-element-loading>
            <action-note
                v-for="note in clientAction.notes"
                :key="note.clientActionNoteId"
                :date="note.createdDate"
                :label="note.label"
                :user="note.user"
                :admin-user="note.admin_user"
                :note="note.note"
                :files="note.files"
            >
            </action-note>
        </b-tab>
    </b-tabs>
    <vue-element-loading :active="loading"></vue-element-loading>
    </div>
</template>

<script>
import TagSelect from '@/components/Form/TagSelect';
import DatePicker from '@/components/Form/DatePicker';
import AssignSelect from '@/components/Form/AssignSelect';
import ClientActionButtons from '@/components/Action/ClientActionButtons';
import ActionNote from '@/components/Action/ActionNote';
import PhotoViewer from '@/components/Image/PhotoViewer';
import dayjs from 'dayjs';
import ActionStatus from '@/services/Action/ActionStatus';
import ClientAction from '@/services/Action/ClientAction';
import ClientActionAssign from '@/services/Action/ClientActionAssign';
import ClientActionPriority from '@/services/Action/ClientActionPriority';
import ClientActionPrioritySelect from '@/components/Form/ClientActionPrioritySelect';
import CategorySelect from '@/components/Form/CategorySelect';
import { forEach, map } from 'lodash';
import Property from '@/services/Property/Property';
import ActionSelect from '@/components/Form/ActionSelect';
import Vue from 'vue';
import PropertyAssessmentType from '@/services/Property/PropertyAssessmentType';
import ClientActionCategory from '@/services/Action/ClientActionCategory';
import AssessmentTypeSelect from '@/components/Form/AssessmentTypeSelect';
import ErrorMixin from '@/components/Notifications/ErrorMixin';
import { categoryForm } from '@/services/Action/ClientActionForm';
import riskhub from "@/services/Riskhub/Riskhub";
import TextField from '@/components/Form/TextField';

export default {
  name: 'Client-Action-Item',
  components: {
    AssessmentTypeSelect,
    ClientActionPrioritySelect,
    AssignSelect,
    TagSelect,
    DatePicker,
    ClientActionButtons,
    ActionNote,
    PhotoViewer,
    ActionSelect,
    CategorySelect,
    TextField,
  },
  mixins: [ErrorMixin],
  props: {
    clientActionId: {
      required: true,
    },
    clientAction: {
      required: true,
    },
    flat: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      assignOptions: [],
      priorityOptions: [],
      priority: {},
      assessmentTypeOptions: [],
      complianceType: {},
      assessmentType: {},
      clientActionCategory: {},
      clientActionCategoryOptions: [],
      clientActionSubCategory: {},
      clientActionSubCategoryOptions: [],
      categoryForm: categoryForm(),
      linkedActionOptions: [],
      linkedAction: {},
      assessmentTypes: [],
      property: {},
      getPhotosFn: () => ClientAction.getPhotos({ clientActionId: this.clientActionId }),
      tabs: {
        notes: {
          loading: false,
        },
      },
      showTags: false,
      form: {
        loading: {
          reviewer: false,
          priority: false,
          dueDate: false,
          tags: false,
          linkedActions: false,
          assessmentType: false,
          clientActionCategory: false,
          clientActionSubCategory: false,
          workOrder: false,
        },
        disabled: {
          reviewer: true,
          priority: true,
          dueDate: true,
          workOrder: true,
        },
        readOnly: [

          {
            uprn: 'UPRN',
            clientActionType: 'Type',
          },
          {
            address: 'Address',
            description: 'Description',
          },
          {
            recommendation: 'Recommendation',
            specification: 'Specification',
          },
          {
            rate: 'Rate',
            table: {
              label: '',
              class: 'w-50',
              fields: [
                {
                  key: 'field',
                  label: '',
                  class: 'font-weight-bold',
                },
                {
                  key: 'min',
                },
                {
                  key: 'max',
                },
              ],
              items: [
              ],
            },
          },
          {
            propertyHierarchyType: 'Hierarchy Level',
            origin: 'Origin',
          },
          {
            designation: 'Designation',
            tenure: 'Tenure',
          },
        ],
      },
    };
  },
  computed: {
    address: {
      get() {
        const { propertyHierarchyType, unitNumber } = this.clientAction;

        const formattedHierarchyAndUnitNumber = propertyHierarchyType && unitNumber
            ? `${propertyHierarchyType} ${unitNumber}`
            : '';

        const validatedStreetNumber = this.clientAction.streetNumber || '';
        const validatedStreet = this.clientAction.street || '';

        return [
          formattedHierarchyAndUnitNumber,
          this.clientAction.numberRange,
          this.clientAction.buildingName,
          `${validatedStreetNumber} ${validatedStreet}`,
          this.clientAction.town,
          this.clientAction.postcode,
        ].filter(Boolean).join('\n');
      },
    },

    authorized: {
      get() {
        return this.clientAction.authorized;
      },
      set() {

      },
    },

    reviewer: {
      get() {
        const label = this.clientAction.currentAssigned;
        const userId = this.clientAction.currentResponsibleUserId;
        const teamId = this.clientAction.currentResponsibleTeamId;
        return {
          label,
          userId,
          teamId,
        };
      },
      set(reviewer) {
        // this.$store.commit('updateReviewer', reviewer);

      },
    },

    tags: {
      get() {
        const tags = this.clientAction.tags;
        if (tags) {
          return tags.split(',').map(tag => ({
            name: tag,
            code: tag,
          }));
        }
        return [];
      },
      set(tags) {
        this.updateTags(tags);
      },
    },

    allowedAssign() {
      if (this.clientAction.status === ActionStatus.APPROVED()) {
        return false;
      }

      return this.authorized && this.$can(this.$perm.ACTIONS_ASSIGN, this.$perm.PERMISSION_TYPE_ACTION);
    },

    allowedToTag() {
      return this.authorized && this.$can(this.$perm.ACTIONS_TAG, this.$perm.PERMISSION_TYPE_ACTION);
    },

    haslinkedAction() {
      return this.clientAction.linkedActionId;
    },

    subStatus() {
      const subStatus = this.clientAction.completionStatus || this.clientAction.secondaryStatus;

      if (!subStatus) {
        return null;
      }

      return ActionStatus.getLabelForSecondaryOrCompletionStatus(subStatus);
    },
  },

  filters: {
    uppercaseFirst(string) {
      if (!string) {
        return '';
      }

      return string.charAt(0)
        .toUpperCase() + string.slice(1);
    },
    brackets(string) {
      if (!string) {
        return '';
      }

      return `(${string})`;
    },
    formatDate(date) {
      if (!date) {
        return 'N/A';
      }

      return riskhub.formatDate(date);
    },
  },

  async mounted() {
    this.setWatchersOnCategories();
    this.showTags = false;
    Vue.$model = ClientAction;
    await this.$store.dispatch('refreshTags');
    this.showTags = true;
  },

  created() {
    this.isModel();
  },

  watch: {
    clientAction: {
      async handler(newClientAction) {
        if (!newClientAction.propertyId) {
          return;
        }

        this.loading = true;
        try {
          await Promise.all([
            this.loadLinkedActions(),
            this.loadAssignOptions(),
            this.loadPriorities(),
            this.loadAssessmentTypes(),
            this.initCategories(),
            this.initRateTable(),
          ]);
        } catch (e) {
          this.$notify({
            duration: 5000,
            title: 'Error',
            text: 'This action could not currently be loaded right now. Please try again later.',
            type: 'error',
          });
          console.log(e);
          this.$emit('close', true);
        } finally {
          this.loading = false;
        }
      },
      immediate: true,
    },
  },

  methods: {
    async loadAssignOptions() {
      if (!this.allowedAssign) {
        return;
      }
      this.assignOptions = await ClientActionAssign.getFormattedOptions(this.activeTeamId);
    },

    async loadPriorities() {
      if (!this.authorized) {
        return;
      }
      const { data } = await ClientActionPriority.list(this.clientAction.originId);
      this.priorityOptions = data.data;
      const priority = this.priorityOptions.find(item => item.clientActionPriorityId === this.clientAction.clientActionPriorityId);
      this.setPriority(priority);
    },

    async loadAssessmentTypes() {
      if (!this.authorized) {
        return;
      }

      const { data } = await PropertyAssessmentType.list(this.clientAction.propertyId, { enabled: 1 });
      const assessmentTypes = [];
      data.data.forEach((item) => {
        assessmentTypes.push(item.assessment_type);
      });

      this.assessmentTypeOptions = assessmentTypes;
      this.setComplianceType(this.assessmentTypeOptions.find(item => item.assessmentTypeId === this.clientAction.assessmentTypeId));
    },

    async loadPropertyDetails() {
      const { data } = await Property.find(this.clientAction.propertyId);
      this.property = data.data;
    },

    /**
     * Setup rate table
     **/
    async initRateTable() {
      const row = this.form.readOnly.find(r => r.table);
      row.table.items = [
        {
          field: 'Qty\'s',
          min: this.clientAction.minQuantity,
          max: this.clientAction.maxQuantity,
        },
        {
          field: 'Costs',
          min: this.clientAction.minCost,
          max: this.clientAction.maxCost,
        },
      ];
    },

    async initCategories() {
      const formElement = this.categoryForm['clientActionCategoryId-0'];
      formElement.options = await this.loadCategories();

      if (this.clientAction.clientActionCategories) {
        const categories = this.clientAction.clientActionCategories;

        categories.forEach((category) => {
          const key = `clientActionCategoryId-${category.depth}`;
          this.categoryForm[key].value = category;
        });
      }
    },

    async loadCategories(parentCategoryId = 0) {
      if (!this.authorized) {
        return;
      }

      const { data } = await ClientActionCategory.list(
        this.clientAction.originId,
        this.clientAction.complianceTypeId,
        parentCategoryId,
      );

      return data.data;
    },

    /**
     * Setup custom watchers for the select dropdowns
     * */
    setWatchersOnCategories() {
      for (let i = 0; i < ClientActionCategory.MAX_DEPTH(); i++) {
        const key = `clientActionCategoryId-${i}`;
        const childKey = `clientActionCategoryId-${i + 1}`;

        const form = this.categoryForm;

        this.$watch(() => form[key].value, async (data) => {
          if (!form[childKey]) {
            return;
          }

          // Reset, will trigger this same watch event for children
          if (!data) {
            form[childKey].value = null;
            return;
          }

          const { clientActionCategoryId } = data;

          if (!clientActionCategoryId) {
            return;
          }

          form[childKey].options = await this.loadCategories(clientActionCategoryId);
        });
      }
    },

    async refreshTags() {
      try {
        const response = await ClientAction.getTags();
        this.tags = response.data.data;
      } catch (e) {
        console.log(e);
      }
    },

    async loadLinkedActions() {
      if (!this.authorized) {
        return;
      }
      const { data } = await Property.getActions(this.clientAction.propertyId);
      const results = [];
      forEach(data.data, (item, key) => {
        results.push({
          ...item,
          label: `${item.clientActionId} - ${item.recommendation}`,
        });
      });

      this.linkedActionOptions = results;
      const linkedAction = this.linkedActionOptions.find(item => item.clientActionId === this.clientAction.linkedActionId);
      if (linkedAction) {
        this.setLinkedAction(linkedAction);
      }
    },

    /**
     * Obtains form value for given field
     */
    getFormValue(field) {
      const costs = [
        'rate',
        'minCost',
        'maxCost',
      ];

      if (costs.includes(field)) {
        if (!this.$can(this.$perm.ACTIONS_VIEW_COSTS, this.$perm.PERMISSION_TYPE_ACTION)) {
          return '';
        }
      }

      if (this[field]) {
        return this[field];
      }

      return this.clientAction[field];
    },

    /**
     * Retrieve notes
     * */
    async getNotes() {
      if (Array.isArray(this.notes)) {
        return;
      }

      this.tabs.notes.loading = true;

      try {
        const { data } = await ClientAction.getNotes({ clientActionId: this.clientActionId });
        const notes = data.data;
        this.clientAction.notes = notes;
      } finally {
        this.tabs.notes.loading = false;
      }
    },

    /**
     * @param newTags
     */
    async updateTags(newTags) {
      this.form.loading.tags = true;

      const tags = newTags.map(tag => tag.name);

      try {
        await this.$store.dispatch('updateTags', { clientActionIds: this.clientActionId, tags });

        this.$notify({
          title: 'Success',
          text: 'This action has been tagged successfully.',
          type: 'success',
        });
        this.$store.dispatch('refreshActions');
        this.$store.dispatch('refreshTags');
        this.$refs.tagSelect.disable();
      } finally {
        this.form.loading.tags = false;
      }
    },

    /**
     * @param newDate
     */
    async updateDueDate(newDate) {
      const params = {
        data: {
          dueDate: newDate,
        },
        successMessage: 'The due date has been updated successfully.',
      };

      try {
        await this.saveAction(params);

        this.$refs.datePicker.disable();
      } catch (e) {
        this.showValidationError(e);
      } finally {
        this.form.loading.dueDate = false;
      }
    },

    /**
     * @param newWorkOrder
     */
     async updateWorkOrder(newWorkOrder) {
      const params = {
        data: {
          workOrder: newWorkOrder,
        },
        successMessage: 'The work order has been updated successfully.',
      };

      try {
        await this.saveAction(params);
      } catch (e) {
        this.showValidationError(e);
      } finally {
        this.form.loading.workOrder = false;
      }
    },

    isModel() {
      if (!this.$model) {
        // throw Error('Model not found in route');
      }
    },

    /**
     * @param newAssignee
     * @returns {Promise<void>}
     */
    async updateAssignee(newAssignee) {
      this.form.loading.reviewer = true;

      const clientActionIds = this.clientActionId;
      const { userId, teamId } = newAssignee;

      const params = {
        clientActionIds,
        userId,
        teamId,
      };

      try {
        const response = await ClientActionAssign.assign(params);
        const { result } = response.data;

        let title = 'Action assigned';
        let text = 'The assignee has been changed successfully.';
        let type = 'success';

        if (!result) {
          title = 'Action not assigned';
          type = 'warn';
          text = 'Action has failed to be assigned. Please check your email for more information.';
          this.$notify({
            duration: 7000,
            title,
            text,
            type,
          });
          return;
        }

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.$refs.assignSelect.disable();
        // Update the action state
        this.$store.dispatch('refreshActions');
      } catch (e) {
        const { error } = e.response.data;
        let text = 'Something went wrong. Please try again later.';
        if (error && error.message) {
          text = error.message;
        }

        this.$notify({
          duration: 7000,
          title: 'Error',
          text,
          type: 'error',
        });
      } finally {
        this.form.loading.reviewer = false;
      }

      try {
        this.$emit('refresh');
      } catch (e) {
        this.$emit('close');
      }
    },
    setPriority(newValue) {
      this.priority = newValue;
    },

    setComplianceType(newValue) {
      this.complianceType = newValue;
    },

    setAssessmentType(newValue) {
      this.assessmentType = newValue;
    },

    setLinkedAction(newValue) {
      this.linkedAction = newValue;
    },

    /**
     * @param newAssignee
     * @returns {Promise<void>}
     */
    async updatePriority(newPriority) {
      this.form.loading.priority = true;

      this.clientAction.clientActionPriorityId = newPriority.clientActionPriorityId;
      const params = {
        data: {
          clientActionPriorityId: this.clientAction.clientActionPriorityId,
        },
        successMessage: 'The priority has been updated successfully.',
      };

      try {
        await this.saveAction(params);
        this.setPriority(newPriority);

        this.$refs.prioritySelect.disable();
      } finally {
        this.form.loading.priority = false;
      }
    },

    /**
     * @param newAssessmentType
     * @returns {Promise<void>}
     */
    async updateAssessmentType(newAssessmentType) {
      this.form.loading.assessmentType = true;

      /*
        * if the assessment type has been updated then we need to null the clientActionCategory
        * and clientActionSubCategory as they will no longer be relevant
       */
      const params = {
        data: {
          complianceTypeId: newAssessmentType ? newAssessmentType.assessmentTypeId : null,
          clientActionCategoryId: null,
          clientActionSubCategoryId: null,
        },
        successMessage: 'The assessment type has been updated successfully.',
      };

      try {
        await this.saveAction(params);

        this.$refs.assessmentTypeSelect.disable();
      } finally {
        this.form.loading.assessmentType = false;
        this.clientAction.complianceTypeId = newAssessmentType.parentTypeId;
        this.clientAction.assessmentTypeId = newAssessmentType.assessmentTypeId;
        // clear the selects and reload the category selects based on the new assessment type
        await this.resetCategorySelect();
        this.loadCategories();
      }
    },

    /**
     * update the sub category select based on the selected category value
     */
    updateClientActionSubCategories(categorySelected) {
      this.$refs.clientActionCategorySelect.disable();
      this.clearSubCategorySelect();
      if (!categorySelected) {
        /**
         * in normal operation the user will select the category and then the sub-category but if
         * the top level category is removed we'll need to force the save
         */
        this.saveCategories();
        return;
      }
      this.clientActionSubCategoryOptions = categorySelected.sub_categories;
    },

    getCategoryValue(depth = 0) {
      return this.categoryForm[`clientActionCategoryId-${depth}`].value;
    },
    async setCategoryValue(value, key) {
      this.categoryForm[key].value = value;
    },
    getAllCategoryIds() {
      return map(this.categoryForm, (category, key) => (category.value ? category.value.clientActionCategoryId : null));
    },

    async saveCategories(value, key) {
      await this.setCategoryValue(value, key);
      const clientActionCategoryIds = this.getAllCategoryIds();
      let clientActionCategoryId = null;
      if (value) {
        clientActionCategoryId = value.clientActionCategoryId;
      }

      const params = {
        data: {
          clientActionCategoryId: [
            ...clientActionCategoryIds,
            clientActionCategoryId,
          ].filter(Number),
        },
        successMessage: 'The categories have been updated successfully.',
      };
      this.loading = true;

      try {
        await this.saveAction(params);
        this.categoryForm[key].disabled = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * @param newTags
     */
    async updateLinkedAction(newLinkedAction) {
      this.form.loading.linkedActions = true;

      const { params, clearCategories, clearPriorites } = this.prepareLinkedActionData(newLinkedAction);

      this.setLinkedActionProperties(newLinkedAction);

      try {
        await this.saveAction(params);

        const newParams = {
          originId: newLinkedAction ? ClientActionCategory.ORIGIN_RISK_ASSESSMENT_ID() : ClientActionCategory.ORIGIN_PROPERTY_ID(),
        };
        this.updateClientAction(newParams);

        this.$refs.linkedActionSelect.disable();
        // this.setAssessmentType(null);
        await this.loadPriorities();
        await this.loadClientActionCategories();
        if (clearPriorites) {
          this.clearPriorityFormModels();
        }
        if (clearCategories) {
          this.clearCategoryFormModels();
        }
      } finally {
        this.form.loading.linkedActions = false;
      }
    },

    async saveAction(params) {
      try {
        await ClientAction.update(this.clientActionId, params.data);

        this.$notify({
          duration: 7000,
          title: 'Success',
          text: params.successMessage,
          type: 'success',
        });
        // Update the action state
        this.$store.dispatch('refreshActions');
      } finally {
      }
    },

    /**
     * clear the models associated with the selected value in the form
     */
    clearCategoryFormModels() {
      this.clientActionCategory = null;
      this.clientActionSubCategory = null;
    },

    resetCategorySelect() {
      this.clientActionCategoryOptions = [];
      this.clientAction.clientActionCategoryId = null;
      this.clearSubCategorySelect();
      this.clearCategoryFormModels();
    },

    clearSubCategorySelect() {
      this.clientActionSubCategoryOptions = [];
      this.clientAction.clientActionSubCategoryId = null;
      this.clientActionSubCategory = null;
    },

    clearPriorityFormModels() {
      this.priority = null;
    },

    setLinkedActionProperties(newLinkedAction) {
      this.clientAction.linkedActionId = newLinkedAction ? newLinkedAction.clientActionId : null;
    },

    prepareLinkedActionData(newLinkedAction) {
      let clearPriorites = false;
      let clearCategories = false;

      // If unlinked or linked
      if (this.clientAction.linkedActionId && !newLinkedAction) {
        clearPriorites = true;
        clearCategories = true;
      } else if (newLinkedAction && !this.clientAction.linkedActionId) {
        clearPriorites = true;
        clearCategories = true;
      } else if (newLinkedAction && newLinkedAction.complianceTypeId !== this.clientAction.complianceTypeId) {
        clearCategories = true;
      }

      const params = {
        data: {
          linkedActionId: newLinkedAction ? newLinkedAction.clientActionId : null,
          complianceTypeId: newLinkedAction ? newLinkedAction.complianceTypeId : this.clientAction.complianceTypeId,
          assessmentTypeId: newLinkedAction ? newLinkedAction.assessmentTypeId : this.clientAction.assessmentTypeId,
          clientActionPriorityId: clearPriorites ? null : this.clientAction.clientActionPriorityId,
          clientActionCategoryId: clearCategories ? null : this.clientAction.clientActionCategoryId,
          clientActionCategory: clearCategories ? null : this.clientAction.clientActionCategory,
          clientActionSubCategoryId: clearCategories ? null : this.clientAction.clientActionSubCategoryId,
          clientActionSubCategory: clearCategories ? null : this.clientAction.clientActionSubCategory,
        },
        successMessage: 'The linked action has been updated successfully.',
      };

      return {
        params,
        clearCategories,
        clearPriorites,
      };
    },

    updateClientAction(params) {
      Object.entries(params).forEach(([key, value]) => {
        this.clientAction[key] = value;
      });
    },

    canViewWorkOrders() {
      return this.$can(this.$perm.ACTIONS_VIEW_WORK_ORDERS, this.$perm.PERMISSION_TYPE_ACTION) ||
          this.$can(this.$perm.ACTIONS_VIEW_ALL, this.$perm.PERMISSION_TYPE_ACTION);
    },
  },
};
</script>

<style lang="scss">
    .v--modal-overlay .v--modal-box {
        overflow-y: auto;
    }

    .b-form-group-content {
        color: $purple;
        font-weight: 300;
    }

    .action-item {
        .form-group {
            margin-bottom: 1.5rem;
        }

        .b-form-group-content.read-only {
            white-space: pre-line;
        }
    }
</style>
